"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationsProps = void 0;
var _constants = require("../constants");
var _logger = require("../logger");
const getTranslationsProps = ({
  language,
  staticApiUrl,
  tenant,
  translations
}) => {
  const result = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: error => {
        _logger.mainLogger.error(error, {
          action: 'Loading translations.'
        });
      },
      tenant
    },
    language,
    defaultTranslationsWithNamespaces: {
      [_constants.translationsNamespace]: _constants.defaultTranslations
    },
    translationsWithNamespaces: translations ? {
      [_constants.translationsNamespace]: translations
    } : undefined
  };
  return result;
};
exports.getTranslationsProps = getTranslationsProps;
